const styObj = {
  default: {
    // ── 页面背景 ────────────────────────────────────────────────────
    '--wd-page-bg': '#f7f6f9', // 页面根背景色

    // ── 余额卡片 ────────────────────────────────────────────────────
    '--wd-balance-gradient': 'linear-gradient(270deg, #ba2cef 0%, #9554f8 100%)', // 余额头部卡片渐变背景

    // ── 提现档位 - 选中态 ───────────────────────────────────────────
    '--wd-price-active-bg': 'rgba(199, 97, 254, 0.2)', // 选中档位背景色
    '--wd-price-active-border': '#c761fe', // 选中档位边框色
    '--wd-price-active-color': '#c761fe', // 选中档位文字色

    // ── 费率角标 ────────────────────────────────────────────────────
    '--wd-fee-badge-bg': '#fe5b87', // 费率角标背景色

    // ── 主题强调色（按钮填充背景、描边、链接） ──────────────────────
    '--wd-theme-color': '#a338fc', // 主题色，用于实色按钮背景、边框、文字链接
    '--wd-theme-btn-color': '#ffffff', // 主题实色按钮文字色（深色主题用白字）

    // ── 弹框专用色 ──────────────────────────────────────────────────
    '--wd-dialog-amount-color': '#8831fe', // 确认弹框中金额高亮色

    // ── 规则区链接色 ────────────────────────────────────────────────
    '--wd-immediately-color': '#a338fc', // 规则中「立即了解」链接色

    // ── 快速提现页 - 条件状态成功图标 ──────────────────────────────
    '--ip-success-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/Withdrawal/default/success.png')})`,
  },

  kiko: {
    // ── 页面背景 ────────────────────────────────────────────────────
    '--wd-page-bg': '#f9f9fb', // 页面根背景色

    // ── 余额卡片 ────────────────────────────────────────────────────
    '--wd-balance-gradient': 'linear-gradient(270deg, #ff560a 0%, #ff8929 100%)', // kiko 橙红渐变

    // ── 提现档位 - 选中态 ───────────────────────────────────────────
    '--wd-price-active-bg': '#fffce6', // 选中档位背景色（浅黄）
    '--wd-price-active-border': '#ffe242', // 选中档位边框色（黄色）
    '--wd-price-active-color': '#b79b21', // 选中档位文字色（暗金）

    // ── 费率角标 ────────────────────────────────────────────────────
    '--wd-fee-badge-bg': '#fe5b87', // 费率角标背景色（与 default 相同）

    // ── 主题强调色 ──────────────────────────────────────────────────
    '--wd-theme-color': '#ffe242', // kiko 主题色（黄色）
    '--wd-theme-btn-color': '#000000', // kiko 实色按钮文字色（浅色主题用黑字）

    // ── 弹框专用色 ──────────────────────────────────────────────────
    '--wd-dialog-amount-color': '#b79b21', // 确认弹框中金额高亮色（暗金）

    // ── 规则区链接色 ────────────────────────────────────────────────
    '--wd-immediately-color': '#006cae', // 规则中「立即了解」链接色（kiko 用蓝色）

    // ── 快速提现页 - 条件状态成功图标 ──────────────────────────────
    '--ip-success-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/Withdrawal/kiko/success.png')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置，回退 default
        else {
          return styObj['default']
        }
      }
      return {}
    },
  },
}
